import { useSelector, useDispatch } from 'react-redux'
import { closeSidebar, goBack } from '@slices/uiSlice'
import Menu from './Menu'
import MenuNavigator from './MenuNavigator'

const MenuShell = () => {
  const dispatch = useDispatch()

  const { isOpen, history } = useSelector((state) => state.ui.sidebar)

  const current = history.at(-1)

  const handleClose = () => {
    dispatch(closeSidebar())
  }

  const handleBack = () => {
    dispatch(goBack())
  }

  return (
    <>
      <div
        className={`standard-normal-menu-shell-background-overlay ${isOpen && 'standard-normal-menu-shell-background-overlay-activated'}`}
        onClick={handleClose}
      />
      <div
        className={`standard-normal-menu-shell-outer-container ${isOpen && 'standard-normal-menu-shell-opened'} ${current && 'standard-normal-menu-shell-option-content-opened'}`}
      >
        <div className="standard-normal-menu-shell-inner-container">
          {!current && <Menu />}
          {current && <MenuNavigator stack={history} onBack={handleBack} onClose={handleClose} />}
        </div>
      </div>
    </>
  )
}

export default MenuShell
